/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import { Link } from 'react-router-dom';
import {
  Tooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Form,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
} from 'reactstrap';
import { Alert, UncontrolledAlert } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ReactQuill from 'react-quill';
import { incoTermTable, deliveryUnit } from '../../common/data';
import ActionMenu from './ActionMenu';

const HpsRequestTab = ({ goNext, goBack, form }) => {
  const [startDate, setStartDate] = useState(null); // from
  const [endDate, setEndDate] = useState(null); // to
  const [termType, setTermType] = useState('TERM');
  const [formData, setFormData] = useState({
    operationtolerance: '0',
    propanerangequantity: '0',
    propanefrequency: '0',
    propanequantity: '0',
    butanerangequantity: '0',
    butanefrequency: '0',
    butanequantity: '0',
    draftmin: '0',
    draftmax: '0',
    loamin: '0',
    loamax: '0',
    dwtmin: '0',
    dwtmax: '0',
  });

  const handleNumberChange = fieldName => e => {
    const input = e.target.value;
    if (isNumericOnly(input)) {
      setFormData(prev => ({
        ...prev,
        [fieldName]: input === '' ? '0' : input,
      }));
    }
  };

  const toggledeletemodal = () => {
    setDeleteModal(!deletemodal);
  };

  const togglemodal = () => {
    setModal(!modal);
  };

  return (
    <React.Fragment>
      <Row>
        <div>
          <h5 className='mb-1'>HPS Request Information</h5>
          <p className='text-muted mb-4'>
            Please select and enter your information
          </p>
        </div>

        <div className='mt-4'>
          <Row>
            <Col sm={3}>
              <div className='mb-2'>
                <Label htmlFor='hpsRequestNumber' className='form-label'>
                  HPS Request Number
                </Label>
                <Input
                  type='text'
                  className='form-control'
                  id='hpsRequestNumber'
                  name='hpsRequestNumber'
                  disabled={true}
                  value={form.hpsRequestNumber || ''}
                />
              </div>

              <div className='mb-2'>
                <Label htmlFor='hpsRequestDate' className='form-label'>
                  Request Date
                </Label>
                <Input
                  type='date'
                  className='form-control'
                  id='hpsRequestDate'
                  name='hpsRequestDate'
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={3}>
              <div className='mb-2'>
                <Label htmlFor='userId' className='form-label'>
                  Request Name
                </Label>
                <select
                  id='userId'
                  name='userId'
                  className='form-select mb-3'
                  aria-label='Default select example'
                >
                  <option>Select Employee Name </option>
                  <option value='1'>Select 1</option>
                  <option value='2'>Select 1</option>
                </select>
              </div>
            </Col>

            <Col sm={3}>
              <div className='mb-2'>
                <Label htmlFor='userIdDept' className='form-label'>
                  Department / Division
                </Label>
                <Input
                  type='text'
                  className='form-control'
                  id='userIdDept'
                  name='userIdDept'
                  disabled={true}
                />
              </div>
            </Col>
          </Row>
        </div>

        <div className='d-flex align-items-start gap-3 mt-4'>
          <button
            type='button'
            className='btn btn-light btn-label previestab'
            onClick={() => {
              goBack();
            }}
          >
            <i className='ri-arrow-left-line label-icon align-middle fs-16 me-2'></i>
            Back to DMUT Invitation
          </button>
          <button
            type='button'
            className='btn btn-primary btn-label right ms-auto nexttab'
            onClick={() => {
              goNext();
            }}
          >
            <i className='ri-truck-line label-icon align-middle fs-16 ms-2'></i>
            Save & Next
          </button>
        </div>
      </Row>
    </React.Fragment>
  );
};

export default HpsRequestTab;
